"use client";
import { BookOpen, Pencil, Sparkles } from "lucide-react";

const LeftComponent = () => {
  return (
    <div className="relative">
      <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-6 shadow-2xl transform hover:scale-105 transition-all duration-500 overflow-hidden">
        <div className="relative rounded-2xl overflow-hidden">
          {/* Main Illustration */}
          <img
            src="/images/children.png"
            alt="Kids Learning Drawing"
            className="rounded-2xl shadow-lg animate-fade-in-up"
          />

          {/* Animated Overlay Elements */}
          <div className="absolute inset-0 pointer-events-none">
            {/* Floating Drawing Elements */}
            <div className="absolute top-4 left-4 w-6 h-6 bg-blue-400/70 rounded-full animate-pulse"></div>
            <div
              className="absolute top-8 right-12 w-4 h-4 bg-green-400/70 rounded-full animate-bounce"
              style={{ animationDelay: "0.5s" }}
            ></div>
            <div
              className="absolute bottom-8 left-8 w-5 h-5 bg-pink-400/70 rounded-full animate-ping"
              style={{ animationDelay: "1s" }}
            ></div>
            <div
              className="absolute bottom-4 right-6 w-6 h-6 bg-yellow-400/70 rounded-full animate-bounce"
              style={{ animationDelay: "1.5s" }}
            ></div>

            {/* Floating Learning Icons */}
            <div className="absolute top-1/4 right-4 animate-float">
              <BookOpen className="w-6 h-6 text-purple-500/70" />
            </div>
            <div
              className="absolute bottom-1/3 left-6 animate-float"
              style={{ animationDelay: "0.8s" }}
            >
              <Pencil className="w-5 h-5 text-orange-500/70" />
            </div>
            <div
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 animate-float"
              style={{ animationDelay: "1.2s" }}
            >
              <Sparkles className="w-7 h-7 text-yellow-500/70" />
            </div>

            {/* Progress Lines Animation */}
            <div className="absolute top-1/2 left-8 w-12 h-0.5 bg-gradient-to-r from-blue-400 to-green-400 animate-pulse"></div>
            <div
              className="absolute top-1/2 right-8 w-10 h-0.5 bg-gradient-to-r from-pink-400 to-purple-400 animate-pulse"
              style={{ animationDelay: "0.3s" }}
            ></div>

            {/* Tablet Screen Glow Effect */}
            <div
              className="absolute bottom-1/4 left-1/4 w-16 h-12 bg-blue-300/20 rounded animate-pulse"
              style={{ animationDelay: "0.7s" }}
            ></div>
            <div
              className="absolute bottom-1/4 right-1/4 w-16 h-12 bg-green-300/20 rounded animate-pulse"
              style={{ animationDelay: "1.1s" }}
            ></div>
          </div>

          {/* Corner Decorations */}
          <div className="absolute -top-2 -left-2 w-6 h-6 bg-yellow-400 rounded-full animate-bounce"></div>
          <div
            className="absolute -top-2 -right-2 w-6 h-6 bg-pink-400 rounded-full animate-bounce"
            style={{ animationDelay: "0.3s" }}
          ></div>
          <div
            className="absolute -bottom-2 -left-2 w-6 h-6 bg-green-400 rounded-full animate-bounce"
            style={{ animationDelay: "0.6s" }}
          ></div>
          <div
            className="absolute -bottom-2 -right-2 w-6 h-6 bg-blue-400 rounded-full animate-bounce"
            style={{ animationDelay: "0.9s" }}
          ></div>
        </div>

        {/* Image Caption */}
        <div className="mt-4 text-center">
          <p className="text-purple-600 font-medium animate-fade-in-up">
            Kids learning through interactive drawing!
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeftComponent;
